/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Text,
  LinkWrapper,
} from 'athenaeum';
import magazineItems from 'templates/MainNav/data/magazineItems';

import styles from './submenu_item.module.scss';
import ProductDisplay from '../ProductDisplay';
import MagazineDisplay from '../MagazineDisplay';
import { trackNavigate } from '../../utils/analytics';

class SubmenuItem extends React.Component {
  constructor() {
    super();

    this.state = {
      windowLocationPathname: '',
    };
  }

  componentDidMount() {
    // Because of the way our SSR works,
    // this has to live in componentDidMount
    // and the isActive has to use state.
    /* eslint-disable react/no-did-mount-set-state */
    if (typeof window !== 'undefined') {
      this.setState({
        windowLocationPathname: window.location.pathname
      });
    }
  }

  get submenuDisplayType() {
    const {
      displayType,
      item,
      mobileCollapsedMenu,
      setMobileCollapsedMenu,
      activeSubTab,
    } = this.props;

    const sharedDisplayProps = {
      intro: item.intro,
      isActive: activeSubTab === item.menu.activeName,
      activeName: item.menu.activeName,
      headerText: item.menu.header,
      mobileCollapsedMenu,
      setMobileCollapsedMenu,
      onClick: this.preventDisplayFromDisappearingOnClick,
    };


    if (displayType === 'magazine') {
      return (
        <MagazineDisplay
          {...sharedDisplayProps}
          description={item.menu.description}
          tag={item.menu.tag}
        />
      );
    }

    if (displayType === 'product') {
      return (
        <ProductDisplay
          {...sharedDisplayProps}
          list={item.list}
          columns={item.menu.columns}
        />
      );
    }

    return null;
  }

  getMobileClick = (activeName) => {
    const {
      showMobileMenu,
      setMobileCollapsedMenu,
    } = this.props;

    if (showMobileMenu) {
      return (e) => {
        e.stopPropagation();
        setMobileCollapsedMenu(activeName);

        return false;
      };
    }

    return () => true;
  }

  getMouseEvent = (value) => {
    if (window.ontouchstart) return false;
    const {
      setActiveSubTab,
    } = this.props;

    return setActiveSubTab(value);
  }

  preventDisplayFromDisappearingOnClick = (e) => {
    e.stopPropagation();
  }

  // onClick needed for tablet devices to open display menu
  tabletOnClick = (e) => {
    const {
      activeSubTab,
      setActiveSubTab,
      item
    } = this.props;
    e.stopPropagation();
    if (activeSubTab) {
      setActiveSubTab(null);
      return false;
    }

    setActiveSubTab(item.menu.activeName);
    return false;
  };

  isActive() {
    const {
      item: {
        menu
      },
      displayType,
      activeSubTab,
    } = this.props;

    const pathname = menu.path || menu.link;
    let isActive = this.state.windowLocationPathname === pathname || activeSubTab === menu.activeName;

    // Sets the life insurance tab as active on the test landing page
    // TEMPORARY WORK AROUND
    // REMOVE IF 25409 ANIMATED HERO LANDING PAGE FAILS, REFACTOR IF WINS
    if (this.state.windowLocationPathname === '/lifeinsurance/' && pathname === '/life-insurance/') {
      isActive = true;
    }

    if (displayType !== 'magazine') { return isActive; }

    const anyMagazineItemsActive = magazineItems.some(item => item.menu.path === this.state.windowLocationPathname);

    if (!anyMagazineItemsActive && menu.activeName === 'latest-magazine') {
      isActive = true;
    }

    return isActive;
  }

  render() {
    const {
      item: {
        menu
      },
      showMobileMenu,
      displayType,
      activeName,
    } = this.props;

    const isActive = this.isActive();

    const headerClasses = classnames(
      styles['item-header-text'],
      isActive && styles.active,
      menu.shortHeader && styles['item-long-header'],
    );

    const linkClasses = classnames(
      styles['item-header-link'],
      // need to add special padding to More link on Tablet
      menu.activeName === 'more' && styles['item-more-link'],
      // need to remove pointer events on tablet for all submenu items
      // except those for 'about', which should still be clickable
      activeName !== 'about' && styles['tablet-no-pointer'],
    );

    return (
      <div
        className={styles.item}
        onClick={this.tabletOnClick}
        onMouseEnter={() => this.getMouseEvent(menu.activeName)}
        onMouseLeave={() => this.getMouseEvent(null)}
      >
        <LinkWrapper
          className={linkClasses}
          href={showMobileMenu && displayType ? null : menu.link}
          onClick={this.getMobileClick(menu.activeName)}
        >
          <Text
            type={10}
            font="b"
            color="neutral-1"
            className={headerClasses}
            onClick={() => trackNavigate({
              navigate_to: this.props.item.menu.link
            })}
          >
            {menu.header}
          </Text>

          {
            menu.shortHeader &&
              <Text
                type={10}
                font="b"
                color="neutral-1"
                className={classnames(headerClasses, styles['item-short-header'])}
              >
                {menu.shortHeader}
              </Text>
          }
        </LinkWrapper>

        { this.submenuDisplayType }
      </div>
    );
  }
}

SubmenuItem.propTypes = {
  item: PropTypes.object,
  showMobileMenu: PropTypes.bool,
  setMobileCollapsedMenu: PropTypes.func,
  displayType: PropTypes.string,
  setActiveSubTab: PropTypes.func,
  activeSubTab: PropTypes.string,
  mobileCollapsedMenu: PropTypes.string,
  activeName: PropTypes.string,
};

export default SubmenuItem;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Submenu/SubmenuItem/index.js